import { renderServiceMenu } from "../functions/menu-functions"
export const chargeData = async (props, payload) => {
    const {
            getUserData, getBalanceUser,
            getEntitiesCore, getInfoCredits, getAditionalCredits,
            getDeposits, getTypeCredits, getParams, getQuotas, getDeviceData, 
            getCollectionsOtherServices, getFoundations,
            getCompany, getStates, getUsersPayroll, getUserPermissions, getMenu 
        } = props
    try {
        getDeviceData(payload.user.id)
        const company = await getCompany(payload.user.company)
        const userData = await getUserData(company.payload[0].cedule)
        await getParams()
        await getStates()
        const { data } = userData.payload
        //console.log(data)
        await getBalanceUser({NumeroCliente: data.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        //await getElectricCompaniesCore()
        await getEntitiesCore()
        //await getAgreements()
        //await getAgreementsSwitchServices()
        await getFoundations()
        await getCollectionsOtherServices()
        const getInfoCreditsCore = await getInfoCredits({NumeroCliente: data.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        const { data: infoCredits } = getInfoCreditsCore.payload
        await getTypeCredits({ SecuencialEmpresa: 1 })
        if (infoCredits.length > 0) {
            // getCredits({SecuencialPrestamo:infoCredits[0].Secuencial, SecuencialEmpresa: 1 })
            await getAditionalCredits({SecuencialPrestamo:infoCredits[0].Secuencial })
        }
        const getDepositsCore = await getDeposits({ NumeroCliente: data.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        const { data: infoDeposits } = getDepositsCore.payload
        if (infoDeposits.length > 0) {
            // await getDepositsAditional({SecuencialDeposito: infoDeposits[0].Secuencial })
            // await getDepositsMovements({SecuencialDeposito: infoDeposits[0].Secuencial, FechaInicio: '', FechaFin: '', SecuencialEmpresa: 1})
        }
        await getQuotas({cedule: data.Identificacion})
        const permissionsuser = await getUserPermissions({user: payload.user.id})

        const menuResult = renderServiceMenu(permissionsuser.payload)

        await getMenu(menuResult)
        await getUsersPayroll()
        /* if (quotaExist.payload.length === 0) {
            feathersCreateData('quotas', {cedule: payload.user.vusk, daily: '40000', weekly: '0', monthly: '10000' })()
        } */
        //await getSiim()
        return Promise.resolve('Data cargada correctamente')
    } catch (error) {
        //console.log('error de loading core',JSON.stringify(error))
        return Promise.reject(error);
    }
    
}
export default chargeData